import company from './company';
import user from './user';

export default [...company, ...user];
